// extracted by mini-css-extract-plugin
module.exports = {"createdDateContainer":"style__createdDateContainer__xZ5ZI"};